module.exports = __webpack_public_path__ + "static/nick_brown-c215751c9551344ef636027a023d9fc1.jpg";